import styled, { css } from "styled-components";

const flexColumn = css`
  display: flex;
  flex-direction: column;
`;

export const Container = styled.div`
  ${flexColumn};
  margin-left: auto;
  position: relative;

  button div[role="span"] {
    margin-right: ${({ theme }) => theme.space["space-1"]};
  }
`;

export const BadgeContainer = styled.div<{
  position: "start" | "end";
}>`
  display: inline-flex;
  position: absolute;
  z-index: 4;
  top: -2px;
  ${({ position }) =>
    position === "start"
      ? css`
          left: 10px;
        `
      : css`
          right: -4px;
        `}
`;
